<template>
  <popup ref="popup" :loading="popupLoading" :before-close="close">
    <div slot="body">
      <el-form
        class="dataForm"
        ref="form"
        :disabled="disabled"
        :model="formParameter"
        :inline="true"
        label-width="140px"
        :rules="rules"
      >
        <el-card class="box-card" style="margin-bottom: 20px">
          <div slot="header" class="clearfix">
            <span
              ><el-tag
                type="danger"
                effect="dark"
                size="medium"
                style="width: 150px; height: 30px; font-size: 18px"
                >报销申请,合计:</el-tag
              ></span
            >
            <span style="color: red; font-size: 21px; margin-left: 5px"
              >{{ countCost }}元</span
            >
          </div>
          <el-row>
            <el-col :span="16">
              <el-form-item label="报销名称" prop="name"
                ><el-input
                  v-model="formParameter.name"
                  autocomplete="off"
                ></el-input
              ></el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="报销日期" prop="reimTime">
                <el-date-picker
                  v-model="formParameter.reimTime"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="报销备注" prop="remarks"
                ><el-input
                  v-model="formParameter.remarks"
                  autocomplete="off"
                  type="textarea"
                  :row="3"
                ></el-input
              ></el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="disabled">
            <el-col :span="12">
              <el-form-item label="报销发起人" prop="name"
                ><el-input
                  v-model="formParameter.userName"
                  autocomplete="off"
                ></el-input
              ></el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="状态" prop="state">
                <select-option-dictionary
                  v-model="formParameter.state"
                  dkey="reim-state"
                ></select-option-dictionary>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="disabled">
            <el-col :span="12">
              <el-form-item label="审批人" prop="sper"
                ><el-input
                  v-model="formParameter.sper"
                  autocomplete="off"
                ></el-input
              ></el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="审批时间" prop="sptm">
                <el-date-picker
                  v-model="formParameter.sptm"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-row>
          <el-col :span="24">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span
                  ><el-tag
                    type="danger"
                    size="medium"
                    style="
                      width: 130px;
                      height: 30px;
                      font-size: 18px;
                      margin-right: 20px;
                    "
                    >报销子项列表</el-tag
                  >
                  <el-button
                    size="small"
                    type="primary"
                    @click="addItms"
                    v-if="openType != 1"
                    icon="el-icon-circle-plus"
                    >添加</el-button
                  >
                </span>
              </div>
              <el-card
                v-for="(item, index) in reimitems"
                :key="index + 1000"
                style="margin-bottom: 20px"
              >
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="子项名称"
                      ><el-input
                        v-model="item.name"
                        autocomplete="off"
                      ></el-input
                    ></el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="9">
                    <el-form-item label="发生时间">
                      <el-date-picker
                        v-model="item.itemTime"
                        type="date"
                        placeholder="选择日期"
                      >
                      </el-date-picker
                    ></el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="金额"
                      ><el-input
                        v-model="item.cost"
                        autocomplete="off"
                        oninput="if(value>10000)value=10000"
                      ></el-input
                    ></el-form-item>
                  </el-col>
                </el-row>
                <el-row  >
                  <el-col :span="8" v-if="openType != 1">
                    <el-form-item label="附件">
                      <file-upload 
                        v-model="item.appendix"
                        model="fileSystem"
                        uri="/statics/reim"
                        :size="128"
                        :showFile="false"
                      >
                      </file-upload
                    ></el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <a
                      target="_blank"
                      :href="item.appendix"
                      :download="item.appendix"
                      style="height: 200px; display: block; width: 200px"
                      v-if="
                        item.appendix &&
                        (item.appendix.substr(
                          item.appendix.lastIndexOf('.') + 1
                        ) == 'jpg' ||
                          item.appendix.substr(
                            item.appendix.lastIndexOf('.') + 1
                          ) == 'jpeg' ||
                          item.appendix.substr(
                            item.appendix.lastIndexOf('.') + 1
                          ) == 'png')
                      "
                    >
                      <img :src="item.appendix" width="100%" height="100%" />
                    </a>
                  </el-col>
                </el-row>
                <div v-if="openType != 1">
                  <el-button
                    size="small"
                    @click="delItms(index)"
                    v-if="reimitems.length != 1"
                    type="danger"
                    icon="el-icon-delete"
                    style="float: right; display: block; margin: 10px 5px"
                    >删除</el-button
                  >
                </div>
              </el-card>
            </el-card>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button
        v-if="!disabled"
        type="primary"
        :loading="confirmLoading"
        @click="confirm()"
        >确 定</el-button
      >
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import fileUpload from "@/components/biz/fileUpload/fileUpload.vue";
import imageUpload from "@/components/biz/imageUpload/imageUpload.vue";
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/cw/reimburses.js";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
export default {
  name: "edit",
  components: {
    fileUpload,
    imageUpload,
    popup,
    selectOptionDictionary,
  },
  data() {
    return {
      aliyunOssValue: "",
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      reimitems: [], //报销子项
      openType: 0,
      formParameter: {},
      rules: {
        //报销名称
        name: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 255,
            trigger: "blur",
          },
        ],
        //报销日期
        reimTime: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
        reimitems: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    //计算报销合计
    countCost() {
      let cost = 0;
      this.reimitems.forEach((item) => {
        if (item.cost) {
          cost += parseFloat(item.cost);
        } else {
          cost += 0;
        }
      });
      return cost;
    },
  },
  methods: {
    //添加子项
    addItms() {
      this.reimitems.push({ cost: "0" });
    },
    //删除子项
    delItms(pos) {
      this.reimitems.splice(pos, 1);
    },
    //上传报销文件
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },

    //打开弹框
    open(parameter, title, openType, disabled, size) {
      this.parameter = parameter;
      this.disabled = disabled;
      this.openType = openType;
      this.$refs.popup.open(title, size);
      if (this.openType == 2) {
        this.reimitems = [{ name: "", cost: 0, itemTime: "" }];
        this.formParameter = {};
      } else {
        this.$nextTick(() => {
          this.init();
        });
      }
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.reimitems = [];

      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;
        console.log(this.reimitems);
        //判断子项必须得有一个且子项名称必须填写
        if (this.reimitems[0].name == "") {
          this.$utils.msg.warning("请填写报销子项名称");
          this.confirmLoading = false;
          return;
        }
        //判断子项必须得有一个且子项日期必须填写
        if (this.reimitems[0].itemTime == "") {
          this.$utils.msg.warning("请填写报销子项日期");
          this.confirmLoading = false;
          return;
        }
        if (!this.parameter.id) {
          //添加
          this.formParameter.reimitems = this.reimitems;
          let parameter = this.$utils.merger(this.formParameter);
          api.save(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        } else {
          //编辑
          this.formParameter.reimitems = this.reimitems;
          let parameter = this.$utils.merger(this.formParameter);
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        }
      });
    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();

      if (this.parameter.id) {
        //编辑查询数据
        let parameter = {
          id: this.parameter.id,
        };
        api.toUpdate(parameter, (response) => {
          this.formParameter = response.data;
          this.reimitems = this.formParameter.reimitems;
          this.popupLoading = false;
        });
      } else {
        this.reimitems.push({ cost: "0" });
        //添加
        this.popupLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
